import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import InputField from "../../components/shared/InputField";
import SelectField from "../../components/shared/SelectField";
import NormalButton from "../../components/shared/NormalButton";
import useUser from "../../components/helpers/useUser";
import Loading from "../../components/shared/Loading";
import { UserContext } from "../../App";
import { FIELDS, firebaseConfig } from "../../components/utils/constants";
import MultiSelect from "../../components/shared/MultiSelect";
import Toast from "../../components/shared/Toast";
import FilterSelectedValues from "../../components/helpers/filterSelectedValues";
import SingleImageCompress from "../../components/helpers/SingleImageCompress";
import {initializeApp, getApp, getApps} from "firebase/app";
import { getStorage, getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";
import moment from "moment";

const UsersEditPage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle(t('workers.editWorkerTitle'));
    const navigate = useNavigate();
    const pageTitle = {title: t('workers.editWorkerTitle')};
    const { id } = useParams();
    const [editUserForm,setEditUserForm] = useState(null);
    const [errors, setErrors] = useState(null);
    const [isEditUserFormDisabled, setIsEditUserFormDisabled] = useState(true);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [user,setUser] = useUser();
    const [vendor, setVendor] = useState(null);
    const {confguration, fields} = useContext(UserContext);
    const [citiesOptions, setCitiesOptions] = useState(null);
    const [districtsOptions, setDistrictsOptions] = useState(null);
    const [originalWorker, setOriginalWorker] = useState(null);
    const [worker, setWorker] = useState(null);
    const [fieldsOptions, setFieldsOptions] = useState(null);
    const [originalCity, setOriginalCity] = useState(null);
    const [subFieldsOptions, setSubFieldsOptions] = useState(null);
    const [selectedGoldiePlan, setSelectedGoldiePlan] = useState(null);
    const [toast, setToast] = useState({show: false,type: null, message:'' });
    const [uploadedFile, setUploadedFile] = useState(null);
    const [compressedImage, setCompressedImage] = useState(null);
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
    
    const fileRef = useRef();

    const convertArabicNumbersToEnglish = string =>
  // eslint-disable-next-line no-bitwise
  string?.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, c => c.charCodeAt(0) & 0xf);

    const handleChangeUpload = (e) => {
        setUploadedFile(e.target.files[0]);
        ResetInputFile();
    }

    const ResetInputFile = () => {
        if(fileRef.current) {
            fileRef.current.value = '';
        }
    }
    
    const getUserData = async () => {
      try {
        const response = await apiClient.get(`/vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }

    

    const getWorker = async () => {
      try {
        const response = await apiClient.get(`/users?types=worker&limit=1&skip=0&partialUsername=${id}`);
        if(response?.data[0]) {
            setIsLoading(false);
            setOriginalCity(response?.data[0]?.city);
            const data= {
                city: response?.data[0]?.city,
                district: response?.data[0]?.district,
                field: response?.data[0]?.fields,
                governmentId: response?.data[0]?.governmentId,
                name: response?.data[0]?.name,
                sponsor: response?.data[0]?.sponsor,
                username: response?.data[0]?.username,
                focusedSpecialization: response?.data[0]?.focusedSpecialization || [],
                residenceDocumentUrl: response?.data[0]?.residenceDocumentUrl
            }
            setOriginalWorker(data);
            setEditUserForm(data);
            setWorker(response?.data[0]);
        } else {

        }
      } catch(err) {}
    }

    
  
    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }


    const handleSubmitAddUser = (url=false) => {
        setErrors(null);
        let errorsList = {};
        if(editUserForm?.name?.length < 2) {
            errorsList.name = 'validation.nameLength';
            }
            if(!/^(5)([0-9]{8})$/.test(editUserForm?.username?.replace('966',''))) {
            errorsList.username = 'validation.invalidmobile';
            }
            if(Object.keys(errorsList).length > 0) {
            setErrors(errorsList);
        } else {
            handleClickSubmitAddUserAction(url);
        }
    }

    const handleClickSubmitAddUserAction = async (url=false) => {
        setIsEditUserFormDisabled(true);
        const finalEditUserForm = {...editUserForm};
        finalEditUserForm.vendorId = vendor?._id;
        finalEditUserForm.fields = finalEditUserForm.field;
        finalEditUserForm.username = convertArabicNumbersToEnglish(finalEditUserForm.username);
        finalEditUserForm.governmentId = convertArabicNumbersToEnglish(finalEditUserForm.governmentId);
        delete finalEditUserForm.field;
        if(url){
            finalEditUserForm.residenceDocumentUrl  = url;
        }
        try {
        const response = await apiClient.patch(`/users/${worker?._id}`,Object.fromEntries(Object.entries(finalEditUserForm).filter(([_, v]) => v !== '')));
        if(response?.data) {
            navigate(`/${i18n?.language || 'ar'}/workers/${worker?.username}`);
        } else {
            setIsEditUserFormDisabled(false);
        }
        } catch(err) {
            setIsEditUserFormDisabled(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
            if(err?.response?.data?.message) {
                setToast({show:true,type:'error',message:err.response.data.message});
            }
        }
    }

   const isTechCountExceeded = () => {
      let status;
      if(vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 && vendor?.workersCount >= vendor?.activeSubscription?.plan?.features?.TechniciansCount) {
        status = true;
      } else {
        status = false;
      }
      return status;
    }


    const getGoldiePlans = async (field,subscriptionType) => {
        setSelectedGoldiePlan(null);
        try {
          const response = await apiClient.get(`/vendor-golden-star-plans/field?field=${field}&subscriptionType=${subscriptionType}`);
          if(response?.data) {
            if(response?.data?.goldenStarPlan?.isActive) {
                setSelectedGoldiePlan(response?.data?.goldenStarPlan);
            } else {
            }
          } else {
          }
        } catch(err) {
        }
    }

    const getRealFields = () => {
        return [...new Set(vendor?.workers?.flatMap(w => w.fields))];
    }

    const handleChangeFields = (options) => {
        if(options && Array.isArray(options)) {
            if(options.length > vendor?.activeSubscription?.plan?.features?.MaxSpecializationsCount) {
                setToast({show:true,type:'error',message:t('workers.maxSpecializationsAdded')});
            } else if(!options.map(o=>o.value).includes(originalWorker?.field[0])) {
                setToast({show:true,type:'error',message:t('workers.cannotEditMainSpec')});
            } else {
                setEditUserForm({ ...editUserForm, field: options.map(o=>o.value) }); 
                hideError('field');
            }
        }
    }

    
    const getTotal = () => {
        let total = 0;
        if((editUserForm?.field?.length > vendor?.activeSubscription?.plan?.features?.SpecializationsCount) && (editUserForm?.field > originalWorker?.field)) {
            total += vendor?.activeSubscription?.plan?.features?.FeesToSpecializations;
        }
        return total;
    }

    

    useEffect(()=>{
        if(fields && vendor) {
            setFieldsOptions(fields?.filter(f=>vendor?.fields?.includes(f?.field?.code))?.map(f=>({value:f.field.code,label:f.field.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || f.field.name.ar,subFields:f?.maintenanceListPerDevice.flatMap(item => item.maintenanceList)})));
        }
    },[fields,vendor])

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
        }
    },[user])

    useEffect(()=>{
        if(id) {
            getWorker();
        }
    },[id])
      
  
    useEffect(()=>{
      if(editUserForm && editUserForm?.name && editUserForm.username && editUserForm.city && editUserForm?.governmentId && editUserForm?.field && (editUserForm?.residenceDocumentUrl || uploadedFile))  {
        if(JSON.stringify(editUserForm) !== JSON.stringify(originalWorker)) {
            setIsEditUserFormDisabled(false);
        } else {
            setIsEditUserFormDisabled(true);
        }
      } else {
        setIsEditUserFormDisabled(true);
      }
    },[editUserForm,originalWorker,uploadedFile]);

    useEffect(()=>{
        if(confguration?.enums?.districts) {
            const citiesOptions = confguration?.enums?.districts?.map((city) => ({
                value: city?.id,
                label: city?.[i18n.language === 'ar' ? 'ar' : 'en'] || city?.ar
            }));
            setCitiesOptions(citiesOptions);
        }
    },[confguration?.enums?.districts])

    useEffect(()=>{
        if(editUserForm?.city && confguration) {
            const districtsOptions = confguration?.enums?.districts[confguration?.enums?.districts.findIndex(district => district?.id === editUserForm?.city)]?.districts?.map((district) => ({
                value: district?.id,
                label: district?.[i18n.language === 'ar' ? 'ar' : 'en'] || district?.ar
            }));
            if(editUserForm?.city !== originalCity) {
                setEditUserForm({ ...editUserForm, district: '' });
            }
            if(districtsOptions) {
                setDistrictsOptions(districtsOptions);
            }
        }
    },[editUserForm?.city,confguration])


    useEffect(()=>{
        if(vendor && !vendor?.activeSubscription) {
            navigate(`/${i18n?.language || 'ar'}/settings/packages`);
        }
        // if(vendor?.city) {
        //     setEditUserForm({ ...editUserForm, city: vendor?.city });
        // }
    },[vendor])

    useEffect(()=>{
          if(editUserForm?.field && fieldsOptions) {
              const subFieldsOptions = fieldsOptions?.filter(item => editUserForm?.field?.includes(item.value))?.flatMap(item => item.subFields)?.map(subField => ({
                value: subField.code,
                label: subField.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || subField.name.ar
            }));
            setSubFieldsOptions(subFieldsOptions);
            setEditUserForm({ ...editUserForm, focusedSpecialization: editUserForm.focusedSpecialization?.filter(item => subFieldsOptions?.flatMap(i => i.value)?.includes(item)) });
          }
        },[editUserForm?.field,fieldsOptions])


    

    useEffect(()=>{
        if(editUserForm?.field && vendor?.activeGoldenStarSubscriptions && Array.isArray(vendor?.activeGoldenStarSubscriptions) && vendor?.activeGoldenStarSubscriptions.length > 0) {
            if(vendor?.activeGoldenStarSubscriptions.find(s=>s?.goldenStarPlan?.field === editUserForm?.field)) {
                getGoldiePlans(editUserForm?.field,vendor?.activeGoldenStarSubscriptions.find(s=>s?.goldenStarPlan?.field === editUserForm?.field)?.goldenStarPlan?.subscriptionType);
            } else {
                setSelectedGoldiePlan(null);
            }
        }
    },[editUserForm?.field,vendor?.activeGoldenStarSubscriptions])


    const replaceResidenceDocument = () => {
        setEditUserForm({ ...editUserForm, residenceDocumentUrl: '' });
    }

    function handlUploadAction() {
        setIsActionLoading(true);
        if(uploadedFile?.type.includes('image')) {
            SingleImageCompress(uploadedFile).then(compressedFile=>setCompressedImage(compressedFile));
        } else {
            setCompressedImage(uploadedFile);
        }
    }

    useEffect(()=>{

        if(compressedImage) {
            const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
            const storage = getStorage(app);
            const file = compressedImage;
            const time = Date.parse(moment().locale('en').format('YYYY-MM-DD HH:mm:ss')) / 1000;
            const storageRef = ref(storage,'workerIdentityImageUrl/'+time);
            const uploadTask = uploadBytesResumable(storageRef, file);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                (error) => {
                    setIsActionLoading(false);
                    setToast({show:true,type:'error',message:t('workers.uploadDocError')});
                },
                () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadedURL) => {
                    handleSubmitAddUser(downloadedURL);
                    setUploadedFileUrl(downloadedURL);
                });
                }
            );
        }

    },[compressedImage])

    const handleClickTryAddUser = () => {
        if(uploadedFile && !uploadedFileUrl) {
            handlUploadAction();
        } else if (uploadedFileUrl) {
            handleSubmitAddUser(uploadedFileUrl);
        } else {
            handleSubmitAddUser();
        }
    }



  return (
    editUserForm && vendor && fields && fieldsOptions && <>
         <div>
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            {vendor && citiesOptions && originalWorker && <MainContent>


                <div className="flex flex-wrap lg:flex-nowrap gap-[24px]">
                    <div className="w-full lg:w-[calc(100%-330px)] order-2 lg:order-1">
                        <div className="px-[10px]">
                            <NormalFormContainer fullWidth={true} heading={t('workers.editTechData')} label={t('workers.editTechnician')}>
                        
                                <div className="mb-[15px]">
                                    <InputField isRequird label={t('workers.fullName')} placeholder={t('workers.typeUsername')} value={editUserForm?.name} error={errors?.name} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setEditUserForm({ ...editUserForm, name: e.target.value }); hideError('name')}} />
                                </div>

                                <div className="mb-[15px]">
                                    <InputField label={t('workers.sponsorName')} isRequird placeholder={t('workers.typeSponsorName')} value={editUserForm?.sponsor} error={errors?.sponsor} errorMessage={errors?.sponsor} translateError={true} onChange={(e)=>{setEditUserForm({ ...editUserForm, sponsor: e.target.value }); hideError('sponsor')}} />
                                </div>

                                <div className="mb-[15px]">
                                    <InputField phone={true} isRequird label={t('workers.mobileNumber')} value={editUserForm?.username?.replace('966','')} error={errors?.username} errorMessage={errors?.username} translateError={true} onChange={(e)=>{ if(e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) { setEditUserForm({ ...editUserForm, username: '966'+e.target.value }) }; hideError('username')}} />
                                </div>

                                <div className="mb-[15px]">
                                    <InputField isRequird label={t('workers.idNumber')} placeholder={t('workers.typeIdNumber')} value={editUserForm?.governmentId || ""} error={errors?.governmentId} errorMessage={errors?.governmentId} translateError={true} onChange={(e)=>{/^([12]\d{0,9})?$/.test(e.target.value.toString()) ? setEditUserForm({ ...editUserForm, governmentId: e.target.value }) : ''; hideError('governmentId')}} />
                                </div>

                                <div className="mb-[15px]">
                                    <MultiSelect isMulti isRequird label={t('workers.specialization')} placeholder={t('workers.chooseSpecialization')} options={fieldsOptions} value={editUserForm?.field} error={errors?.field} errorMessage={errors?.field} translateError={true} onChange={(options)=>{handleChangeFields(options)}} />
                                </div>

                                {(editUserForm?.field && subFieldsOptions && subFieldsOptions.length > 0) ? <div className="mb-[15px]">
                                    <MultiSelect isMulti label={t('workers.subSpecializations')} placeholder={t('workers.chooseSubSpecializations')} options={subFieldsOptions} error={errors?.focusedSpecialization} errorMessage={errors?.focusedSpecialization} value={editUserForm?.focusedSpecialization} onChange={(options)=>{setEditUserForm({ ...editUserForm, focusedSpecialization: FilterSelectedValues(options)});hideError('focusedSpecialization');}} />
                                </div> : ''}

                                {editUserForm?.city && citiesOptions &&<div className="mb-[15px]">
                                    <SelectField disabled={true} label={t('workers.city')} placeholder={t('workers.chooseCity')} options={citiesOptions} value={editUserForm?.city} error={errors?.city} errorMessage={errors?.city} translateError={true} onChange={(e)=>{setEditUserForm({ ...editUserForm, city: e.target.value }); hideError('city')}} />
                                </div>}

                                {editUserForm?.city && districtsOptions && <div className="mb-[15px]">
                                    <SelectField label={t('workers.district')} placeholder={t('workers.chooseDistrict')} options={districtsOptions} value={editUserForm?.district} error={errors?.district} errorMessage={errors?.district} translateError={true} onChange={(e)=>{setEditUserForm({ ...editUserForm, district: e.target.value }); hideError('district')}} />
                                </div>}


                                <div>
                                    <label htmlFor={'residenceDocumentUrl'} className="text-grey-900 text-[14px] font-[600] leading-[21px] mb-[3px] block">{t('workers.residenceDocument')} <span className="text-danger">*</span></label>
                                    {/* <p className="font-[500] text-[13px] text-grey-950 my-[10px]"> </p> */}
                                    {editUserForm?.residenceDocumentUrl ?
                                    <div className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                        <div className="w-[75%] text-grey-600 text-[16px] font-[500]"><Link to={editUserForm?.residenceDocumentUrl} target="_blank" className="text-blue underline">{t('workers.viewDoc')}</Link></div>
                                        <div className="w-[25%] text-end"><div className="cursor-pointer text-darkBlue underline" onClick={replaceResidenceDocument}>{t('workers.editDoc')}</div></div>
                                    </div>
                                    :<><div className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                        <div className="w-[75%] text-grey-600 text-[16px] font-[500]">{t('workers.uploadDoc')}</div>
                                        <div className="w-[25%] text-end">
                                            <div className={`inline-block text-[16px] font-[500] cursor-pointer select-none text-blue relative`}>
                                                <input type="file" id="file" name="file" accept=".pdf,.png,.jpg,.jpeg" ref={fileRef} onChange={handleChangeUpload} className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" />
                                                <span dir="lrt inline-block h-[24px] leading-[24px]">{t('workers.upload')}</span>
                                                <span className="inline-block align-top w-[24px] h-[24px] ms-[5px]" style={{background:"url('/assets/images/export.svg')"}}></span>
                                            </div>
                                        </div>
                                    </div>
                                    {uploadedFile && <div className="flex flex-nowrap gap-x-[10px] mb-[15px] mt-[-5px]">
                                        <div className="text-[16px] font-[500] text-grey-600">
                                            <span className="inline-block align-middle w-[24px] h-[24px] me-[3px]" style={{background:"url('/assets/images/tick-circle.svg')"}}></span>
                                            {uploadedFile?.name}
                                            <span className="inline-block align-middle w-[24px] h-[24px] ms-[6px] cursor-pointer select-none" style={{background:"url('/assets/images/close-square.svg')"}} onClick={()=>{setUploadedFile(null);setUploadedFileUrl(null);}}></span>
                                        </div>
                                    </div>}</>}
                                </div>
                                

                                <div className="text-end">
                                    <NormalButton label={t('workers.editData')} onClick={handleClickTryAddUser} isDisabled={isEditUserFormDisabled} />
                                </div>

                            </NormalFormContainer>
                        </div>
                    </div>
                    <div className="w-full lg:w-[330px] lg:pt-[120px] order-1 lg:order-2">
                        {getTotal() > 0 && <div className="bg-white p-[16px] rounded-[8px]">
                            {/* {isTechCountExceeded() && <div className="flex flex-nowrap pb-[16px] border-b-[1px] border-grey-300 border-dashed">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500] leading-[24px]">اضافة فني جديد</div>
                                <div className="w-[25%] text-end text-[14px] text-grey-900 font-[500]">{vendor?.activeSubscription?.plan?.features?.ExtraTechsFees} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline max-w-[11px] me-[4px]" /></div>
                            </div>} */}
                            {editUserForm?.field?.length > vendor?.activeSubscription?.plan?.features?.SpecializationsCount ? <div className="py-[16px] border-b-[1px] border-grey-300 border-dashed flex flex-nowrap">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500] leading-[24px]">{t('workers.addNewSpec')}</div>
                                <div className="w-[25%] text-end text-[14px] text-grey-900 font-[500]">{vendor?.activeSubscription?.plan?.features?.FeesToSpecializations || 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline max-w-[11px] me-[4px]" /></div>
                            </div> : ''}
                            {/* {selectedGoldiePlan && selectedGoldiePlan?.workersCountInField >= selectedGoldiePlan?.techniciansCount ? <div className="py-[16px] border-b-[1px] border-grey-300 border-dashed flex flex-nowrap">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500] leading-[24px]">اشتراك Goldie</div>
                                <div className="w-[25%] text-end text-[14px] text-grey-900 font-[500]">{selectedGoldiePlan?.extraTechniciansFees || 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline max-w-[11px] me-[4px]" /></div>
                            </div> : ''} */}
                            <div className="py-[16px] flex flex-nowrap">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500] leading-[24px]">{t('workers.totalAmount')}</div>
                                <div className="w-[25%] text-end text-[14px] text-grey-900 font-[500]">{getTotal()} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline max-w-[11px] me-[4px]" /></div>
                            </div>
                            {getTotal() > vendor?.credits && <div className="h-[29px] flex flex-nowrap">
                                <div className="w-[calc(100%-90px)] text-[14px] text-danger font-[500] leading-[29px]">{t('workers.insufficientBalance')}</div>
                                <div className="w-[90px] text-end">
                                    <Link to={`/${i18n?.language || 'ar'}/wallet`} className="inline-block bg-blue text-white text-center text-[14px] font-[500] h-[29px] leading-[29px] w-[90px] rounded-[8px]" reloadDocument>{t('workers.rechargeWallet')}</Link>
                                </div>
                            </div>}
                        </div>}
                    </div>
                </div>

                <br />
                <br />
                
            </MainContent>}
        </PageMain>
        </div>
        <Toast toast={toast} setToast={setToast} />
        {(isLoading || !vendor || !fieldsOptions) && <Loading showLoading={true} />}
    </>
  );
};

export default UsersEditPage;
